<template>
    <div>
        <div class="partners">
            <div class="container">
                <partner/>
            </div>
        </div>
    </div>
</template>

<script>
    import Partner from '../components/Partner.vue';

    export default {
        name: 'partners',
        components: {
            Partner,
        },
        data () {
            return {
                documentId: '',
                partners: [],
                linkResolver: this.$prismic.linkResolver,
                hasContent: false,
                show: false,
            }
        },
        methods: {
            getContent () {
                //Query to get partners content
                this.$prismic.client.getSingle('partners')
                    .then((document) => {
                        if (document) {
                            this.documentId = document.id
                            //Check that the partner partners contains content
                            this.checkForContent();
                        } else {
                            //returns error page
                            this.$router.push({ name: 'not-found' })
                        }
                    })
            },
            //Function to check for any content on the partner partners page
        }
    }
</script>

<style lang="scss">
    .partners {
        width:100%;
        text-align: center;
        margin-top: 100px;
    }
    .partners h1.partners-title {
        margin: 2rem;
    }
    .partners .partner-avatar {
        height: 140px;
        width: 140px;
        border-radius: 50%;
        background-position: center;
        background-size: cover;
        margin: 1em auto;
    }
    .partners .partner-image {
        height: 140px;
        width: 100%;
        background-repeat: no-repeat;
    }
    .partners .partners-description {
        font-size: 18px;
        color: #9A9A9A;
        line-height: 30px;
    }
    /* Media Queries */
    @media (max-width: 767px) {
        .partners {
            padding: 0;
            margin: 20px 0;
            .partners-bg {
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover;
                width: 100%;
                height: 10vh;
            }
        }
        /*
        .partners-content {
            position: absolute;
            top: 75vh;
            height: 25vh;
            background: rgba(0,0,0,0.7);
            width: 100%;
            border: 0;
            margin: 0;
        }
        .partners-content h1 {
            color: #fff;
            font-size: 65px;
        }
        .partners-content .partners-description {
            border: 0;
            margin: 0;
            padding-bottom: 1rem;
            color: #fff;
        }*/
        .partners-content span.arrow-down {
            color: white;
            font-size: 30px;
        }
    }
</style>
